import { render, staticRenderFns } from "./trxvendor.vue?vue&type=template&id=15a3ad5f&scoped=true"
import script from "./trxvendor.vue?vue&type=script&lang=js"
export * from "./trxvendor.vue?vue&type=script&lang=js"
import style0 from "./trxvendor.vue?vue&type=style&index=0&id=15a3ad5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3ad5f",
  null
  
)

export default component.exports